import { mailingCommunicationStore } from '@/services/MailingCommunications/store'
import { notifyError, notifyMessage } from '@/services/notify'
import { KMS_BACKEND } from '@/config'

export const methods = {
  async saveMessageForFinalize(content, subject) {
    console.debug('finalizeMessage postal...' + content + ', ' + subject + ', ')

    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    if (content === undefined || !content || content.length === 0) {
      notifyError('The message is required.')
      return
    }

    this.$store.dispatch('communication/composedEmailMessage', {
      emailMessage: content
    })
    this.composedText = content

    this.$store.dispatch('communication/composedEmailSubject', {
      emailMessageSubject: subject
    })
    this.composedSubject = subject

    loadingComponent.close()
  },

  async finalizeMessageFromState(showMessage) {
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    try {
      if (
        this.composedText &&
        this.composedText.length > 0 &&
        (this.mailingCommunicationID || this.communicationID)
      ) {
        const params = {
          communicationID: this.mailingCommunicationID
            ? this.mailingCommunicationID
            : this.communicationID,
          supportMailDelivery: false,
          supportEmailDelivery: true,
          supportSMSDelivery: false,
          supportPushDelivery: false,
          isLegalCommunication: false,
          description: this.communicationDescription,
          mailingTypeID: this.mailingTypeID,
          selectedDeliveryOwnerIDs: this.selectedDeliveryOwnerIDs,
          selectedDeliveryOwners: this.selectedDeliveryOwners,
          deliveryDate: this.deliveryDate,
          htmlEmailContent: this.composedText,
          emailSubject: this.composedSubject,
          emailPriority: 'normal'
        }

        console.debug('mail params=' + JSON.stringify(params))

        await mailingCommunicationStore.dispatch('updateCommunicationMessage', {
          params,
          done: async ({ detail }) => {
            this.$store.dispatch('communication/saveIsEdit', {
              isEdit: true
            })

            if (detail) {
              console.debug('update communication=' + JSON.stringify(detail))

              this.communicationID = detail.communicationID

              this.$store.dispatch('communication/saveIsEdit', {
                isEdit: true
              })

              if (showMessage !== undefined && showMessage && showMessage === true) {
                notifyMessage('This email has been saved for sending.')
              }
            }
          }
        })
      }
    } catch (error) {
      console.debug('error=' + error.message)
      loadingComponent.close()
    }

    loadingComponent.close()
  },

  async handleImageAdded(file, Editor, cursorLocation) {
    console.debug('in handleImageAdded...' + cursorLocation)

    const loadingComponent = this.$buefy.loading.open({
      container: null
    })
    try {
      console.debug('file=' + file)

      if (file !== undefined && file && (this.mailingCommunicationID || this.communicationID)) {
        const payload = {
          communicationID: this.mailingCommunicationID
            ? this.mailingCommunicationID
            : this.communicationID,
          cursorPosition: cursorLocation,
          supportsMail: false,
          supportsEmail: true,
          description: this.communicationDescription,
          isAttachment: true
        }

        console.debug('payload addConversationAttachment=' + JSON.stringify(payload))

        await mailingCommunicationStore.dispatch('addCommunicationAttachment', {
          payload,
          done: async ({ detail }) => {
            if (detail) {
              console.debug('addCommunicationAttachment=' + JSON.stringify(detail))

              const payload = {
                communicationAttachmentID: detail.communicationAttachmentID,
                file: file
              }

              await mailingCommunicationStore
                .dispatch('uploadCommunicationAttachmentDocument', {
                  payload: payload
                })
                .then(async returnedfile => {
                  this.$store.dispatch('communication/saveIsEdit', {
                    isEdit: true
                  })

                  if (returnedfile && detail) {
                    console.debug('returnedfile=' + JSON.stringify(returnedfile))

                    Editor.insertEmbed(
                      cursorLocation,
                      'image',
                      `${KMS_BACKEND}/MailingComponents/CommunicationAttachment/GetFilePublic?token=${detail.securityToken}`
                    )
                  }
                })
            }
          }
        })
      }
    } catch (e) {
      setTimeout(() => loadingComponent.close(), 1000)
      notifyError(e)
    }

    setTimeout(() => loadingComponent.close(), 1000)
  },

  async handleImageRemoved(file) {
    console.debug('in handleImageRemoved...')
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    const flatContents = JSON.stringify(file)
    const flatContentsSplit = flatContents.split('communicationAttachmentID=')
    const communicationAttachmentID = parseInt(
      flatContentsSplit[1] !== undefined && flatContentsSplit[1] ? flatContentsSplit[1] : 0
    )

    console.debug('communicationAttachmentID=' + communicationAttachmentID)

    if (communicationAttachmentID > 0) {
      try {
        await mailingCommunicationStore.dispatch('deleteCommunicationAttachment', {
          communicationAttachmentID,
          done: () => {}
        })
      } catch (e) {
        loadingComponent.close()
        console.debug('There was an issue deleting this communication attachment.' + e)
      }
    }

    this.$store.dispatch('communication/saveIsEdit', {
      isEdit: true
    })

    loadingComponent.close()
  },

  processFinalPreview(content, subject) {
    console.debug('in processFinalPreview Email...' + content)
    this.$store.dispatch('communication/composedEmailMessage', {
      emailMessage: content
    })

    this.$store.dispatch('communication/composedEmailSubject', {
      emailMessageSubject: subject
    })

    this.composedText = content
    this.composedSubject = subject
    this.visiblePage = 'FinalPreview'
  },

  async processAttachments() {
    console.debug('in processAttachments Email...')
    this.visiblePage = 'EmailAttachments'
    await this.getAttachments()

    console.debug('attachments=' + JSON.stringify(this.communicationAttachments))
  },

  async deleteDropFile(index) {
    this.files.splice(index, 1)
    this.previews.splice(index, 1)
  },

  async processSendTestEmail(content, emailSubject) {
    const loadingComponent = this.$buefy.loading.open({
      container: null
    })

    if (emailSubject === undefined || !emailSubject) {
      notifyError('The email subject is required.')
      loadingComponent.close()
      return
    }

    if (content === undefined || !content) {
      notifyError('The email message is required.')
      loadingComponent.close()
      return
    }

    await mailingCommunicationStore.dispatch('sendEmailMessage', {
      hoaID: this.hoaId,
      subject: emailSubject,
      message: content,
      done: async ({ detail }) => {
        console.debug('detail=' + detail)
        this.$store.dispatch('communication/saveIsEdit', {
          isEdit: true
        })

        if (detail) {
          notifyMessage(`Successfully sent a test email to ${this.authUser.email || ''}.`)
        }
      }
    })

    loadingComponent.close()
  },

  async finalizeMessage(content, emailSubject) {
    if (this.hasReadonly === false) {
      console.debug('finalizeMessage...')

      const loadingComponent = this.$buefy.loading.open({
        container: null
      })

      if (emailSubject === undefined || !emailSubject) {
        notifyError('The email subject is required.')
        loadingComponent.close()
        return
      }

      if (content === undefined || !content) {
        notifyError('The email message is required.')
        loadingComponent.close()
        return
      }

      if (content && content.length > 0 && (this.mailingCommunicationID || this.communicationID)) {
        this.$store.dispatch('communication/composedEmailMessage', {
          emailMessage: content
        })
        this.composedText = content

        this.$store.dispatch('communication/composedEmailSubject', {
          emailMessageSubject: emailSubject
        })
        this.composedSubject = emailSubject

        const params = {
          communicationID: this.mailingCommunicationID
            ? this.mailingCommunicationID
            : this.communicationID,
          supportMailDelivery: false,
          supportEmailDelivery: true,
          supportSMSDelivery: false,
          supportPushDelivery: false,
          isLegalCommunication: false,
          description: this.communicationDescription,
          mailFullDuplex: null,
          mailColor: null,
          htmlEmailContent: content,
          emailSubject: emailSubject,
          emailPriority: 'normal'
        }

        await mailingCommunicationStore.dispatch('updateCommunicationMessage', {
          params,
          done: async ({ detail }) => {
            this.$store.dispatch('communication/saveIsEdit', {
              isEdit: true
            })

            if (detail) {
              console.debug('update communication=' + JSON.stringify(detail))

              this.communicationID = detail.communicationID

              this.$store.dispatch('communication/saveIsEdit', {
                isEdit: true
              })

              notifyMessage('This email has been saved for sending.')
            }
          }
        })

        loadingComponent.close()
      }
    }
  },

  loadFromState() {
    this.communicationID = this.$route.params.id

    if (this.isDebug == true) console.debug('compose email communicationID=' + this.communicationID)

    this.composedText = this.emailMessage || ''
    this.composedSubject = this.emailSubject || ''
    console.debug('loadFromState...' + this.composedText + ', subject=' + this.composedSubject)
  }
}
